// Services Imports
import AuthService from '_services/rest/auth';
import UserService from '_services/rest/modules/user';
import sessionService from '_services/common/sessionService';
import { cloneDeep } from '_utils';
import { MODEL } from './components/UserModel';

export default {
  state: {
    user: sessionService.getLocalData('_user'),
    token: sessionService.getLocalData('_token'),
    isAdmin: false,
    userList: null,
    userEdit: null,
  },

  mutations: {
    updateUser(state, user) {
      state.user = user;
    },
    updateToken(state, token) {
      state.token = token;
    },
    setIfAdmin(state, userType) {
      state.isAdmin = userType === 1;
    },
    setUserList(state, response) {
      state.userList = response;
    },
    setUser(state, response) {
      state.userEdit = Object.assign(cloneDeep(MODEL), response);
    },
  },

  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(({ token, userUpdate }) => {
        commit('updateUser', userUpdate);
        commit('updateToken', token);
        commit('setIfAdmin', userUpdate.settings.user_type_id);
      });
    },

    logout({ commit }) {
      return AuthService.logout().then(() => {
        commit('updateUser', null);
        commit('updateToken', null);
      });
    },

    sendForgotPass(context, email) {
      return AuthService.forgetPassword(email);
    },

    saveUser({ commit }, user) {
      return UserService.save(user).then(response => {
        const { modules } = sessionService.getLocalData('_user');
        if (modules) {
          user = Object.assign(response.data, { modules });
        }
        sessionService.setLocalData('_user', user);
        commit('updateUser', user);
        return response;
      });
    },

    checkAdmin({ commit }) {
      const { settings } = this.state.user.user;
      commit('setIfAdmin', settings.user_type_id);
      return this.state.user.isAdmin;
    },

    getUserList({ commit }, params) {
      return UserService.getList(params)
        .then(response => {
          commit('setUserList', response);
        });
    },

    getUser({ commit }, params) {
      return UserService.getUserById(params)
        .then(response => {
          commit('setUser', response);
        });
    },

    setUserEdit({ commit }, params) {
      commit('setUser', params);
    },
  },
};
